import React, { useState, useEffect } from "react";
import dayjs from "dayjs";

import { useDispatch, useSelector } from "react-redux";
import { useSnackbar } from "notistack";
import {
  Grid,
  Typography,
  useMediaQuery,
  useTheme,
  TextField,
} from "@mui/material";
import UnicornLoading from "../../../assets/loading.gif";
import ButtonBlue from "../../../shared/buttonBlue";
import HeaderFooter from "../../../admin/carManagement/components/headerFooter";
import { postDeleteDeliverySampleshuttle } from "../../../../../actions/deliverySampleshuttle";
import { getDeliverySampleshuttleByAdminFilter } from "../../../../../actions/deliverySampleshuttle";
require("dayjs/locale/th");
dayjs.locale("th");

const columns = [
  { id: "sender", label: "ผู้ส่ง", align: "center", width: "240px" },
  { id: "sampleName", label: "ชื่อตัวอย่าง", align: "center", width: "160px" },
  {
    id: "dateTimeStart",
    label: "วัน - เวลา ที่เริ่ม",
    align: "center",
    width: "120px",
  },
  { id: "place", label: "ต้นทาง - ปลายทาง", align: "center", width: "240px" },
  { id: "status", label: "สถานะ", align: "center", width: "140px" },
  { id: "action", label: "การจัดการ", align: "center", width: "80px" },
];

const DeliverySampleShuttleCar = (props) => {
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();
  const { result, isFetching: loading } = useSelector(
    (state) => state.deliverySampleShuttleCar
  );
  const [AllBookingDeliverySampleShuttle, setAllBookingDeliverySampleShuttle] =
    useState(result["รอรับสินค้า"]);
  const [
    FormattedBookingDeliverySampleShuttle,
    setFormattedBookingDeliverySampleShuttle,
  ] = useState([]);
  const [deliverySampleStatus, setDeliverySampleStatus] =
    useState("รอรับสินค้า");
  const handleStatusFilter = (sampleStatus) => {
    setAllBookingDeliverySampleShuttle(result[sampleStatus]);
    setDeliverySampleStatus(sampleStatus);
  };

  const onClickNewList = () => {
    props.history.push({
      pathname: `/admin/car_management/delivery_sample_shuttle/formDetailFlight`,
      state: {
        userType: "admin",
        isEditList: false,
        isNewList: true,
      },
    });
  };

  const onClickCardHandler = (typeOfBooking, idBooking) => {
    console.log("Clicked Booking ID:", idBooking);
    console.log("Type of Booking:", typeOfBooking);

    const booking = AllBookingDeliverySampleShuttle?.find(
      (book) => book.idDeliverySampleShuttle === idBooking
    );

    if (booking) {
      props.history.push(
        "/admin/car_management/delivery_sample_shuttle/detail",
        {
          booking: booking,
        }
      );
    } else {
      console.warn("Booking not found for ID:", idBooking);
    }
  };

  const handleEditBooking = (idBooking) => {
    const booking = AllBookingDeliverySampleShuttle?.find(
      (book) => book.idDeliverySampleShuttle === idBooking
    );

    if (booking) {
      props.history.push(
        "/admin/car_management/delivery_sample_shuttle/edit_detail",
        {
          booking: booking,
        }
      );
    } else {
      console.warn("Booking not found for ID:", idBooking);
    }
  };

  const [deletingBookingId, setDeletingBookingId] = useState("");
  const [openDeleteModal, setOpenDeleteModal] = useState("");

  const onClickDelete = async () => {
    const id = deletingBookingId;
    const myData = {
      id: id,
    };
    console.log("deleting : " + myData.id);
    if (myData.id !== undefined && myData.id) {
      const data = await dispatch(postDeleteDeliverySampleshuttle(myData))
        .then((res) => {
          if (res.status === 200) {
            enqueueSnackbar("Delete Success", { variant: "success" });
            setOpenDeleteModal(false);
            if (props.formData) {
              dispatch(getDeliverySampleshuttleByAdminFilter(props.formData));
            }
          } else {
            enqueueSnackbar("Delete Failed", { variant: "error" });
          }
        })
        .catch((error) => {
          console.log(error);
        });
    }
  };

  const [searchQuery, setSearchQuery] = useState("");

  useEffect(() => {
    if (
      AllBookingDeliverySampleShuttle &&
      AllBookingDeliverySampleShuttle.length
    ) {
      const formatDate = (date) => dayjs(date).format("D MMM YYYY");
      const formattedData = AllBookingDeliverySampleShuttle.map((booking) => ({
        bookingId: booking.idDeliverySampleShuttle,
        nameLabel: "ผู้ส่ง ",
        name: booking.nameSender,
        phone: booking.phoneSender,
        sampleName: booking.nameSample,
        startDateLabel: "วันที่เริ่ม ",
        startDate: formatDate(booking.date),
        startTime: booking.startTime + "น.",
        fromPlace: `Site ${booking.fromPlaceNoSite}: ${booking.fromPlaceName}`,
        toPlace: `Site ${booking.toPlaceNoSite}: ${booking.toPlaceName}`,
        status: booking.deliveryStatus,
      }));

      // Apply filter based on searchQuery
      const filteredData = searchQuery
        ? formattedData.filter((item) =>
            item.sampleName.toLowerCase().includes(searchQuery.toLowerCase())
          )
        : formattedData;

      setFormattedBookingDeliverySampleShuttle(filteredData);
    } else {
      setFormattedBookingDeliverySampleShuttle([]);
    }
  }, [AllBookingDeliverySampleShuttle, searchQuery]);

  const theme = useTheme();
  const isMd = useMediaQuery(theme.breakpoints.up("md"));

  const statusOptions = [
    {
      label: "รอรับสินค้า",
      color: "#F44336",
      hoverColor: "#d9392e",
      bgColor: "#ff091105",
    },
    {
      label: "รับสินค้าเรียบร้อย",
      color: "#FF9800",
      hoverColor: "#de8500",
      bgColor: "#ffb60005",
    },
    {
      label: "ส่งสินค้าเรียบร้อย",
      color: "#2196F3",
      hoverColor: "#1878c7",
      bgColor: "#0088ff08",
    },
    { label: "ได้รับสินค้าเรียบร้อย" },
  ];

  return (
    <div>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          flexWrap: "wrap",
          gap: "1rem",
          paddingBlock: "16px",
        }}
      >
        {/* Search Bar & Status Buttons */}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            flexWrap: "wrap",
            gap: "16px",
            flex: 1,
          }}
        >
          {/* Search Input */}
          <TextField
            id="outlined-basic"
            label="ค้นหาชื่อตัวอย่าง"
            variant="outlined"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            fullWidth={!isMd}
            sx={{
              "& .MuiOutlinedInput-root": {
                borderRadius: "8px",
              },
              minWidth: "220px",
            }}
          />

          {/* Status Buttons (Stick to Search) */}
          <div
            style={{
              display: "flex",
              gap: "12px",
              overflowX: "auto",
              flexWrap: "wrap",
            }}
          >
            {statusOptions.map(({ label, color, hoverColor, bgColor }) => (
              <ButtonBlue
                key={label}
                variant={
                  deliverySampleStatus === label ? "contained" : "outlined"
                }
                customColor={color}
                sx={
                  color
                    ? deliverySampleStatus === label
                      ? {
                          "&:hover": {
                            borderColor: hoverColor,
                            backgroundColor: hoverColor,
                          },
                        }
                      : {
                          "&:hover": {
                            backgroundColor: bgColor,
                            borderColor: hoverColor,
                          },
                        }
                    : {}
                }
                onClick={() => handleStatusFilter(label)}
              >
                {label}
              </ButtonBlue>
            ))}
          </div>
        </div>

        {/* Add Booking Button (Separate) */}
        <ButtonBlue
          variant="contained"
          startIcon={
            <img
              src="/assets/Image/Icon/form.png"
              alt="Logo"
              style={{ width: "20px", height: "20px" }}
            />
          }
          onClick={onClickNewList}
          sx={{ whiteSpace: "nowrap" }}
        >
          เพิ่มการจองรถ
        </ButtonBlue>
      </div>

      {!loading ? (
        AllBookingDeliverySampleShuttle &&
        AllBookingDeliverySampleShuttle.length ? (
          <HeaderFooter
            columns={columns}
            listAllBooking={FormattedBookingDeliverySampleShuttle}
            typeOfBooking={"DeliverySampleShuttleCar"}
            onClickCardHandler={onClickCardHandler}
            deliverySampleStatus={deliverySampleStatus}
            handleEditBooking={handleEditBooking}
            onClickDelete={onClickDelete}
            setOpenDeleteModal={setOpenDeleteModal}
            setDeletingBookingId={setDeletingBookingId}
            openDeleteModal={openDeleteModal}
            listOfAction={["edit", "delete"]}
          />
        ) : (
          <Grid item xs={12} style={{ textAlign: "center" }}>
            <Typography style={{ textAlign: "center", fontSize: "24px" }}>
              ไม่มีรายการ
            </Typography>
          </Grid>
        )
      ) : (
        <Grid item xs={12} container justifyContent="center" marginTop={2}>
          <img
            src={UnicornLoading}
            alt="Loading..."
            style={{ width: "300px" }}
          />
        </Grid>
      )}
    </div>
  );
};

export default DeliverySampleShuttleCar;
